export default __webpack_public_path__ + "static/media/army_42.a48dae9a.jpg";